import React, { useState, useEffect } from "react";
import { Form, InputNumber, Button, Card, Typography, Row, Col } from "antd";

const { Title, Text } = Typography;

const BreakEvenPointCalculator = () => {
  const [breakEvenYears, setBreakEvenYears] = useState(null);
  const [currency, setCurrency] = useState("$");

  const formatNumber = (value) => {
    if (!value) return "";
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const parseNumber = (value) => {
    return value ? value.replace(/\s/g, "") : "";
  };

  useEffect(() => {
        fetch("https://ipapi.co/json/")
          .then((res) => res.json())
          .then((data) => {
            const countryCode = data.country_code; // e.g., ZA, US
            setCurrency(getCurrencyCode(countryCode));
          })
          .catch((err) => {
            console.error("Error fetching currency:", err);
            setCurrency("$"); // Fallback
          });
      }, []);
    
      const getCurrencyCode = (countryCode) => {
        const currencyMap = {
          ZA: "R",   // South Africa
          US: "$",   // United States
          GB: "£",   // United Kingdom
          NG: "₦",   // Nigeria
          KE: "KES", // Kenya
          IN: "₹",   // India
        };
        return currencyMap[countryCode] || "$";
      };

  const calculateBreakEven = (values) => {
    const { propertyPrice, closingCosts, renovationCosts, monthlyRent, annualExpenses } = values;
    
    const totalInvestment = propertyPrice + closingCosts + renovationCosts;
    const annualRentIncome = monthlyRent * 12;
    const annualNetCashFlow = annualRentIncome - annualExpenses;
    
    const breakEvenTime = annualNetCashFlow > 0 ? (totalInvestment / annualNetCashFlow).toFixed(2) : "N/A";
    setBreakEvenYears(breakEvenTime);
  };

  return (
    <Card title="Break-Even Point Calculator (Cash Purchase)" style={{ maxWidth: 800, margin: "auto", marginTop: 20 }}>
      <Row gutter={24}>
        <Col span={15}>
          <Form layout="vertical" onFinish={calculateBreakEven} initialValues={{ propertyPrice: 400000, closingCosts: 40000, renovationCosts: 10000, monthlyRent: 6000, annualExpenses: 30000 }}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label={"Property Price (" + currency + ")"} name="propertyPrice" rules={[{ required: true, message: "Please enter the property price" }]}> 
                  <InputNumber style={{ width: "100%" }} min={1} step={1000} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={"Closing Costs (" + currency + ")"} name="closingCosts" rules={[{ required: true, message: "Please enter closing costs" }]}> 
                  <InputNumber style={{ width: "100%" }} min={0} step={1000} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label={"Renovation Costs (" + currency + ")"} name="renovationCosts" rules={[{ required: true, message: "Please enter renovation costs" }]}> 
                  <InputNumber style={{ width: "100%" }} min={0} step={1000} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={"Monthly Rent Income (" + currency + ")"} name="monthlyRent" rules={[{ required: true, message: "Please enter monthly rent" }]}> 
                  <InputNumber style={{ width: "100%" }} min={1} step={100} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label={"Annual Expenses (" + currency + ")"} name="annualExpenses" rules={[{ required: true, message: "Please enter annual expenses" }]}> 
                  <InputNumber style={{ width: "100%" }} min={0} step={100} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Calculate Break-Even Point
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={9}>
          {breakEvenYears !== null && (
            <Card style={{ textAlign: "center" }}>
              <Title level={4}>Break-Even Time</Title>
              <Text strong style={{ fontSize: "18px" }}>
                {breakEvenYears} years
              </Text>
            </Card>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default BreakEvenPointCalculator;
